import qs from "qs";
import type { RegisterOAuth } from "../types";


export function createRegisterOAuthQuery(registerOAuth: RegisterOAuth) {
  return qs.stringify(
    {
      company: registerOAuth.company,
      plan: registerOAuth.plan,
      competitors: registerOAuth.competitors ?? [],
      selectedCompetitors: registerOAuth.selectedCompetitors ?? [],
    },
    { allowEmptyArrays: true },
  );
}

export function parseRegisterOAuthQuery(query: string) {
  return qs.parse(query, { allowEmptyArrays: true });
}
